import React, { useEffect } from 'react';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import TableConstantActions from '../../../../components/TableConstantActions';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetJnjPaymentListRequest } from '../../../../models/request/jnjPayment/GetJnjPaymentListRequest';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetJnjPaymentListRequest
    setFilter: React.Dispatch<React.SetStateAction<GetJnjPaymentListRequest>>
    onSearchSubmit: (e: any) => void
    selectedCount: number
    /** "Şimdi Çek" yalnız rolünde bu menüde Güncelle yetkisi olana gösterilir (backend de kontrol eder). */
    canFetch: boolean
    isRunning: boolean
    onFetch: () => void
}

const JnjPaymentListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    setFilter,
    onSearchSubmit,
    selectedCount,
    canFetch,
    isRunning,
    onFetch,
}: Props) => {
    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                searchOnly
                hideSearch
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {
                canFetch && (
                    <div className='m-0'>
                        <button
                            type='button'
                            onClick={onFetch}
                            disabled={isRunning}
                            title="PO Eşleştirme'deki bugün geçerli PO numaralarını J&J portalında sorgular"
                            className='btn btn-sm fw-bold btn-primary'
                        >
                            {
                                isRunning
                                    ? <React.Fragment><span className='spinner-border spinner-border-sm me-2' />Çekiliyor…</React.Fragment>
                                    : <React.Fragment><i className='fa fa-cloud-download-alt fs-6 me-1' />Şimdi Çek</React.Fragment>
                            }
                        </button>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default JnjPaymentListFilters;
